import React from 'react';
import ProjectSummary from './ProjectSummary';

const ProjectsList = ({
        projects, authToken, createProjectToken, deleteProjectToken
    }) => (
    <div className="project-list-container">
        { projects.map(project => (
            <ProjectSummary
                project={project}
                key={project.id}
                authToken={authToken}
                createProjectToken={createProjectToken}
                deleteProjectToken={deleteProjectToken}
            />
        ))}
    </div>
);

export default ProjectsList;



// WEBPACK FOOTER //
// ./src/containers/Projects/ProjectsList.js